// Read hook: working papers (each carrying its transaction `referenceNo` link;
// CES rows load separately via useCesRows).
//
// Role-scoped like useTransactions (owner feedback point 7): admins read all via
// the SDK; everyone else gets only their own allocations' working papers through
// the server-scoped proxy. Shares the scoped query key with the other read hooks.
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../lib/queryKeys';
import {
  fetchWorkingPapers,
  fetchMyRegister,
  type ScopedRegister,
  type WorkingPaperRead,
} from '../lib/db';
import { useAuth } from '../lib/auth';

export function useWorkingPapers() {
  // Real role drives the fetch (admin = full read; the page scopes the view).
  const { realRole, user } = useAuth();
  const isAdmin = realRole === 'admin';
  const email = user?.email ?? '';
  return useQuery<WorkingPaperRead[] | ScopedRegister, Error, WorkingPaperRead[]>({
    queryKey: isAdmin ? queryKeys.workingPapers : queryKeys.scopedRegisterFor(email),
    queryFn: isAdmin ? fetchWorkingPapers : fetchMyRegister,
    select: (d) => (isAdmin ? (d as WorkingPaperRead[]) : (d as ScopedRegister).workingPapers),
    enabled: isAdmin || (!!realRole && email.length > 0),
  });
}
